// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class WorkflowModel {
    static getAttributeTypeMap() {
        return WorkflowModel.attributeTypeMap;
    }
}
WorkflowModel.discriminator = undefined;
WorkflowModel.attributeTypeMap = [
    {
        "name": "caseWorkflow",
        "baseName": "caseWorkflow",
        "type": "CaseWorkflowModel"
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": "Array<PayorModel>"
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": "Array<PrescriberModel>"
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": "Array<PharmacyModel>"
    }
];
//# sourceMappingURL=workflowModel.js.map